/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deals_SubtitleInputs */

const cs_deals_subtitle = /** @type {(inputs: Deals_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrování, seznam nebo přetahování karet mezi fázemi.`)
};

const en_deals_subtitle = /** @type {(inputs: Deals_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List, filter, or drag deals between stages.`)
};

/**
* | output |
* | --- |
* | "List, filter, or drag deals between stages." |
*
* @param {Deals_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deals_subtitle = /** @type {((inputs?: Deals_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deals_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deals_subtitle(inputs)
	return cs_deals_subtitle(inputs)
});